import { useEffect, useRef } from 'react'
import { ContactWebSocket } from '../api/ws'
import { useContactStore } from '../store/contactStore'

export function useLiveContacts() {
  const { upsertContact, removeContact, setLiveConnected } = useContactStore()
  const wsRef = useRef<ContactWebSocket | null>(null)

  useEffect(() => {
    const ws = new ContactWebSocket()
    wsRef.current = ws

    ws.onConnected = () => setLiveConnected(true)
    ws.onDisconnected = () => setLiveConnected(false)

    const remove = ws.addHandler((msg) => {
      if ((msg.type === 'contact.new' || msg.type === 'contact.update') && msg.data) {
        upsertContact(msg.data)
      } else if (msg.type === 'contact.removed' && msg.data?.id) {
        removeContact(msg.data.id)
      }
    })

    ws.connect()

    return () => {
      remove()
      ws.disconnect()
      setLiveConnected(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
